import React from "react";
import { useTranslation } from "react-i18next";

import "./Impressum.scss";

const Impressum = () => {
    const { t } = useTranslation();

    return (
        <section className="impressum-section">
            <div className="container">
                <div className="impressum-content">

                    <h1>
                        {t("impressum.title")}
                    </h1>

                    <h2>
                        {t("impressum.ddg.title")}
                    </h2>

                    <p>
                        <strong>
                            Zahnärztliche Gemeinschaftspraxis Pankraz &amp; Lichagin
                        </strong>
                    </p>

                    <p>
                        Frau Tatjana Pankraz
                        <br />
                        Herr Sergey Lichagin
                    </p>

                    <p>
                        Elverdisser Str. 42
                        <br />
                        D-33729 Bielefeld
                        <br />
                        Deutschland
                    </p>

                    <h2>
                        {t("impressum.contact.title")}
                    </h2>

                    <p>
                        {t("impressum.contact.phone")}
                        &nbsp; | &nbsp;
                        {t("impressum.contact.fax")}
                        <br />
                        {t("impressum.contact.email")}
                    </p>

                    <h2>
                        {t("impressum.chamber.title")}
                    </h2>

                    <p>
                        {t("impressum.chamber.text")}
                    </p>

                    <h2>
                        {t("impressum.approval.title")}
                    </h2>

                    <p>
                        {t("impressum.approval.text")}
                    </p>

                    <h2>
                        {t("impressum.professionalRules.title")}
                    </h2>

                    <p>
                        {t("impressum.professionalRules.p1")}
                    </p>

                    <p>
                        {t("impressum.professionalRules.p2")}
                    </p>

                    <h2>
                        {t("impressum.responsible.title")}
                    </h2>

                    <p>
                        Zahnärztliche Gemeinschaftspraxis Pankraz &amp; Lichagin
                    </p>

                    <p>
                        Elverdisser Str. 42
                        <br />
                        D-33729 Bielefeld
                        <br />
                        Deutschland
                    </p>

                    <p>
                        <strong>
                            {t("impressum.vat")}
                        </strong>
                    </p>

                    <h2>
                        {t("impressum.liability.title")}
                    </h2>

                    <h3>
                        {t("impressum.liability.content.title")}
                    </h3>

                    <p>
                        {t("impressum.liability.content.p1")}
                    </p>

                    <p>
                        {t("impressum.liability.content.p2")}
                    </p>

                    <h3>
                        {t("impressum.liability.links.title")}
                    </h3>

                    <p>
                        {t("impressum.liability.links.p1")}
                    </p>

                    <p>
                        {t("impressum.liability.links.p2")}
                    </p>

                    <p>
                        {t("impressum.liability.links.p3")}
                    </p>

                    <p>
                        {t("impressum.liability.links.p4")}
                    </p>

                    <p>
                        {t("impressum.liability.links.p5")}
                    </p>

                    <h3>
                        {t("impressum.copyright.title")}
                    </h3>

                    <p>
                        {t("impressum.copyright.p1")}
                    </p>

                    <p>
                        {t("impressum.copyright.p2")}
                    </p>

                    <p>
                        {t("impressum.copyright.p3")}
                    </p>

                </div>
            </div>
        </section>
    );
};

export default Impressum;